import { createSelector } from 'reselect';

import { getRoundIdFromProps } from '../../../../selectors/_propsGetters_';
import { GRAssetsBySkinId } from '../../constants/assets';
import { selectGRGlobalSkinId, selectGRGlobalState } from '../../selectors/global/globalPrimary.selector';
import {
  selectGRMiscCurrentNotification,
  selectGRMiscTmpNotifications,
} from '../../selectors/misc/miscPrimary.selector';
import { selectIsGRRoundLocked, selectIsGRRoundWon } from '../../selectors/round.selector';
import { selectGRRoundsState } from '../../selectors/rounds/roundsPrimary.selector';
import { selectGRUserState } from '../../selectors/user/userPrimary.selector';
import GRAdventure from '../../states/user';
import { GRNotificationTypes } from '../../types/notification';
import { ObfGRRounds } from '../../types/round';

const makeSelectGRRoundPropsSelector = () => {
  const selectBackground = createSelector(
    [selectGRGlobalState, selectGRGlobalSkinId, selectIsGRRoundLocked, getRoundIdFromProps],
    (gr, skinId, isLocked, roundId) =>
      gr && skinId && !!roundId
        ? GRAssetsBySkinId[skinId]?.Backgrounds?.[isLocked ? 'locked' : 'unlocked']?.[roundId]
        : '',
  );

  const selectAnimation = createSelector(
    [selectGRGlobalState, selectGRGlobalSkinId, getRoundIdFromProps],
    (gr, skinId, roundId) => (gr && skinId && !!roundId ? GRAssetsBySkinId[skinId]?.RoundAnimations?.[roundId] : ''),
  );

  const selectHasUserPotentiallyEnoughPoints = createSelector(
    [selectGRUserState, selectGRRoundsState, getRoundIdFromProps],
    (userState, rounds, roundId) => userState.round === roundId && GRAdventure.hasEnoughPoints(userState, rounds),
  );

  const selectShowVideoTutorialButton = createSelector([getRoundIdFromProps], (roundId) => ObfGRRounds[roundId] === 1);

  const selectHasCompleteNotification = createSelector(
    [selectGRMiscCurrentNotification, selectGRMiscTmpNotifications],
    (currentNotif, notifications) =>
      currentNotif && currentNotif.type === GRNotificationTypes.ROUND_COMPLETE && notifications.length === 1,
  );

  const selectShowAlert = createSelector(
    [selectIsGRRoundWon, selectHasUserPotentiallyEnoughPoints, selectHasCompleteNotification],
    (isWon, hasUserPotentiallyEnoughPoints, hasCompleteNotification) =>
      !isWon && !hasCompleteNotification && hasUserPotentiallyEnoughPoints,
  );

  return createSelector(
    [
      selectIsGRRoundLocked,
      selectIsGRRoundWon,
      selectBackground,
      selectAnimation,
      selectGRGlobalSkinId,
      selectShowAlert,
      selectShowVideoTutorialButton,
      getRoundIdFromProps,
    ],
    (isLocked, isWon, backgroundPath, animationId, skinId, showAlert, showVideoTutorialButton, roundId) => {
      return {
        isLocked,
        isWon,
        backgroundPath,
        animationId,
        skinId,
        showAlert,
        roundId,
        showVideoTutorialButton: !isWon && showVideoTutorialButton,
      };
    },
  );
};

export default makeSelectGRRoundPropsSelector;
